import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

// First, before any module that builds a zod schema: the flag is read at
// construction time (N-29, see lib/zodConfig).
import '@/lib/zodConfig'
import { App } from '@/app/App'
// Initialises i18next before the first render, so no surface paints in the
// fallback language and then swaps (FR-58).
import '@/i18n/config'
import '@/styles/index.css'

const container = document.getElementById('root')
if (!container) throw new Error('Root element #root is missing from index.html')

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
